import { render } from "./mentions_line.vue?vue&type=template&id=0e41a1da"
import script from "./mentions_line.js?vue&type=script&lang=js"
export * from "./mentions_line.js?vue&type=script&lang=js"

import "./mentions_line.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__